__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = undefined;
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@sentry/react", "9.20.0", () => (Promise.all([__webpack_require__.e(546), __webpack_require__.e(759)]).then(() => (() => (__webpack_require__(7546))))));
			register("cropperjs", "1.6.2", () => (__webpack_require__.e(129).then(() => (() => (__webpack_require__(3129))))));
			register("dompurify", "3.0.6", () => (__webpack_require__.e(856).then(() => (() => (__webpack_require__(7856))))));
			register("flatpickr", "4.6.13", () => (__webpack_require__.e(527).then(() => (() => (__webpack_require__(8527))))));
			register("jquery", "3.6.1", () => (__webpack_require__.e(755).then(() => (() => (__webpack_require__(9755))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(759)]).then(() => (() => (__webpack_require__(3935))))));
			register("react", "18.3.1", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))));
			register("select2", "4.1.0-rc.0", () => (Promise.all([__webpack_require__.e(686), __webpack_require__.e(24)]).then(() => (() => (__webpack_require__(686))))));
			register("signature_pad", "5.0.4", () => (__webpack_require__.e(672).then(() => (() => (__webpack_require__(7672))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};